import {
  BarChart3,
  ClipboardList,
  Database,
  LayoutDashboard,
  LucideIcon,
  ShieldCheck,
} from 'lucide-react';

export const ROUTES_ACCESS: RoutesAccessType[] = [
  {
    route: '/',
    accessProfile: [
      'NOVO',
      'ADMINISTRADOR',
      'REPRESENTANTE',
      'ADMINISTRADOR_REVENDA',
    ],
  },
  {
    route: '/market-research',
    accessProfile: ['ADMINISTRADOR', 'REPRESENTANTE', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/market-research/seller-coverage',
    accessProfile: ['ADMINISTRADOR', 'REPRESENTANTE', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/market-research/reseller-coverage',
    accessProfile: ['ADMINISTRADOR', 'REPRESENTANTE', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/market-research/settings',
    accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/market-research/details',
    accessProfile: ['ADMINISTRADOR', 'REPRESENTANTE', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/market-research/packaging-research',
    accessProfile: ['ADMINISTRADOR', 'REPRESENTANTE', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/market-research/products-not-searched',
    accessProfile: ['ADMINISTRADOR', 'REPRESENTANTE', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/market-research/map',
    accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/masterdata/resale',
    accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/masterdata/product',
    accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/masterdata/pdv',
    accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/masterdata/non-research-reason',
    accessProfile: ['ADMINISTRADOR'],
  },
  {
    route: '/access/user',
    accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
  },
  {
    route: '/access/user-permissions',
    accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
  },
];

export const SIDENAV_ITEMS: SidenavItems[] = [
  {
    id: 1,
    label: 'Início',
    section: 'Menu',
    Icon: LayoutDashboard,
    to: '/',
    accessProfile: [
      'NOVO',
      'ADMINISTRADOR',
      'REPRESENTANTE',
      'ADMINISTRADOR_REVENDA',
    ],
  },
  {
    id: 10,
    label: 'Planejamento de Pesquisa',
    section: 'Menu',
    Icon: ClipboardList,
    to: '/market-research',
    accessProfile: ['ADMINISTRADOR', 'REPRESENTANTE', 'ADMINISTRADOR_REVENDA'],
  },
  {
    id: 15,
    label: 'Cobertura por Vendedor',
    section: 'Menu',
    Icon: BarChart3,
    to: '/market-research/seller-coverage',
    accessProfile: ['ADMINISTRADOR', 'REPRESENTANTE', 'ADMINISTRADOR_REVENDA'],
  },
  {
    id: 20,
    label: 'Dados Mestre',
    section: 'Gestão',
    Icon: Database,
    subItems: [
      {
        id: 20.2,
        label: 'Revendas',
        to: '/masterdata/resale',
        accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
      },
      {
        id: 20.3,
        label: 'Produtos',
        to: '/masterdata/product',
        accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
      },
      {
        id: 20.1,
        label: 'PDVs',
        to: '/masterdata/pdv',
        accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
      },
      {
        id: 20.4,
        label: 'Não Pesquisa',
        to: '/masterdata/non-research-reason',
        accessProfile: ['ADMINISTRADOR'],
      },
    ],
    accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
  },
  {
    id: 30,
    label: 'Controle de Acesso',
    section: 'Gestão',
    Icon: ShieldCheck,
    subItems: [
      {
        id: 30.1,
        label: 'Usuários',
        to: '/access/user',
        accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
      },
      {
        id: 30.2,
        label: 'Permissões de Acesso',
        to: '/access/user-permissions',
        accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
      },
    ],
    accessProfile: ['ADMINISTRADOR', 'ADMINISTRADOR_REVENDA'],
  },
];

export type RoutesAccessType = {
  route: string;
  accessProfile: string[];
};

export type SidenavItems = {
  id: number;
  label: string;
  section?: string;
  to?: string;
  Icon?: LucideIcon;
  subItems?: SidenavItems[];
  accessProfile?: string[];
};
